import { gql } from "@apollo/client"

export const VENDOR_DETAIL_FRAG = gql`
  fragment VendorDetailFrag on BaseUserType {
    id
    firstName
    lastName
    fullName
    isBlocked
    blockRemark
    username
    dateOfBirth
    number
    gender
    email
    education
    kycDetails {
      id
      idNumber
      kycType {
        id
        name
      }
      photo
    }
    # routepoints {
    #   id
    #   route {
    #     id
    #     name
    #   }
    # }
    address {
      id
      village
      address
      pincode
      taluka
      state
      district
      latitude
      longitude
    }
    groups {
      id
      name
    }
    customerId
    status
  }
`
